import { Page } from '@/core/architecture'

import { ConsoleDmRoomCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleDmRoomCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleDmRoomCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleDmRoomCreateTemplate state={state} {...actions} />
}
